import { ButtonGroup } from 'ui/buttonGroupV2/ButtonGroup';
import { BUTTON_GROUP_TYPES } from 'ui/buttonGroupV2/types';
import noop from 'utils/noop';

const DATA_TEST = {
  jsonView: 'json-view-toggle',
  tableView: 'table-view-toggle',
};

// type Props = {
//   /** If catalog table is in table view mode. */
//   isTableView: boolean,
//   /** Callback function when `isTableView` value changes. */
//   onChange: (e: {}, updatedProps: {}) => void,
// };

export const TableViewSettingsToggle = ({ isTableView = false, onChange = noop }) => {
  const handleClickTable = (e) => {
    onChange(e, { isTableView: true });
  };

  const handleClickJson = (e) => {
    onChange(e, { isTableView: false });
  };

  return (
    <div style={{ float: 'right' }}>
      <ButtonGroup
        options={[
          {
            id: DATA_TEST.jsonView,
            'data-test': DATA_TEST.jsonView,
            children: 'JSON',
            onClick: handleClickJson,
          },
          {
            id: DATA_TEST.tableView,
            'data-test': DATA_TEST.tableView,
            children: 'Table',
            onClick: handleClickTable,
          },
        ]}
        defaultSelectedIds={isTableView ? [DATA_TEST.tableView] : [DATA_TEST.jsonView]}
        type={BUTTON_GROUP_TYPES.SINGLE_SELECT}
      />
    </div>
  );
};
